import { subDays } from 'date-fns';

export const getPrevDay = (day) => subDays(day, 1);
